import { Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";

type Props = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

const CountdownView = ({ days, hours, minutes, seconds }: Props) => {
  return (
    <Flex w="full" mb={5}>
      <SimpleGrid
        columns={4}
        placeItems="center"
        bg="red.600"
        color="white"
        p={3}
        h="20"
        w="full"
      >
        <Box textAlign="center">
          <Text fontWeight="bold" fontFamily="Graduate">
            {days}
          </Text>
          <Text mt={-1} fontSize={["sm", "md"]}>
            DAYS
          </Text>
        </Box>
        <Box textAlign="center">
          <Text fontWeight="bold" fontFamily="Graduate">
            {hours}
          </Text>
          <Text mt={-1} fontSize={["sm", "md"]}>
            HOURS
          </Text>
        </Box>
        <Box textAlign="center">
          <Text fontWeight="bold" fontFamily="Graduate">
            {minutes}
          </Text>
          <Text mt={-1} fontSize={["sm", "md"]}>
            MINUTES
          </Text>
        </Box>
        <Box textAlign="center">
          <Text fontWeight="bold" fontFamily="Graduate">
            {seconds}
          </Text>
          <Text mt={-1} fontSize={["sm", "md"]}>
            SECONDS
          </Text>
        </Box>
      </SimpleGrid>
    </Flex>
  );
};

export default CountdownView;
